import { useQuery } from '@tanstack/react-query'
import { fetchVATPostingMethods, IGeneralConstantOption } from '../constants'
import { useBusinessContext } from '@root/context'

export const useVATPostingMethods = () => {
  const { slug } = useBusinessContext()

  return useQuery<IGeneralConstantOption[]>({
    queryKey: [slug, 'vat_posting_methods'],
    queryFn: () => fetchVATPostingMethods({ slug }),
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnMount: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!slug
  })
}
